import { Tag, type TagProps, api } from 'common';

export const FlowRunState = api.FlowRun.FlowRunState;
export type FlowRunState = api.FlowRun.FlowRunState;
export const BlockExecutionState = api.FlowRun.FlowBlockState;
export type BlockExecutionState = api.FlowRun.FlowBlockState;

export const TerminalFlowRunStates = [...api.FlowRun.TerminalFlowRunStates];

export const FLOW_RUN_TAG_PROPS: Record<
  FlowRunState,
  {
    color: TagProps['color'];
  }
> = {
  [FlowRunState.Pending]: {
    color: 'pending',
  },
  [FlowRunState.PendingRetry]: {
    color: 'pending',
  },
  [FlowRunState.Queued]: {
    color: 'pending',
  },
  [FlowRunState.Running]: {
    color: 'primary',
  },
  [FlowRunState.Completed]: {
    color: 'success',
  },
  [FlowRunState.Failed]: {
    color: 'error',
  },
  [FlowRunState.Canceled]: {
    color: 'error',
  },
};

interface FlowRunStateTagProps {
  state: FlowRunState;
}

export function FlowRunStateTag(props: FlowRunStateTagProps) {
  const { state } = props;
  return <Tag {...FLOW_RUN_TAG_PROPS[state]}>{state}</Tag>;
}
